app.controller('cookies', ['$scope', function ($scope) {
  $scope.getCookie = function (name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return null;
    } else {
      begin += 2;
      var end = document.cookie.indexOf(";", begin);
      if (end == -1) {
        end = dc.length;
      }
    }
    return decodeURI(dc.substring(begin + prefix.length, end));
  };

  if (! $scope.getCookie('cookiesAccepted')) {
    $scope.cookieNoticeVisible  = true;
  } else {
    $scope.cookieNoticeVisible = false;
  }

  $scope.acceptCookies = function () {
    $scope.createCookie('cookiesAccepted', 'true', 365);
    $scope.cookieNoticeVisible = false;
  };

  $scope.createCookie = function (name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  };

  $scope.readCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i=0;i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  };

  $scope.eraseCookie = function (name) {
    $scope.createCookie(name, "", -1);
  };

  // As soon as this loads, assume cookies are accepted.
  // This means they don't have to click agree for the message to disappear on their next page load.
  $scope.createCookie('cookiesAccepted', 'true', 365);
}]);
